"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getForegroundColorForColor;
exports.getForegroundColorPerBackgroundContrast = getForegroundColorPerBackgroundContrast;
var _colors = require("../colors");
//TODO: this should just return the color, not an object with the color property

/**
 * Calculate the foreground color based on the provided hex contrast
 *
 * Returns an object with a color field containing the calculated
 * foreground color
 * @param hex
 */
function getForegroundColorPerBackgroundContrast(hex) {
  var convertHexToRgb = function convertHexToRgb(color) {
    if (color[0] == "#") {
      color = color.slice(1);
    }
    var num = parseInt(color, 16);
    var r = num >> 16;

    /*
    These values wont occur with our current colors
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    */

    var g = num >> 8 & 0x00FF;

    /*
    These values wont occur with our current colors
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    */

    var b = num & 0x0000FF;

    /*
    These values wont occur with our current colors
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    */

    return ["".concat(r), "".concat(g), "".concat(b)];
  };
  var white = '#FFFFFF';
  var black = '#000000';
  var getTxtColor = function getTxtColor(hex) {
    if (!hex) return white;

    // Needs to be converted to rgb to calculate individual color type values
    var rgbVals = convertHexToRgb(hex);
    var contrast = Math.round((parseInt(rgbVals[0]) * 299 + parseInt(rgbVals[1]) * 587 + parseInt(rgbVals[2]) * 114) / 1000);
    var bgContrast = 122;
    // By adding to bgContrast it will require darker bg to change text to light &
    // same other way around for lighter bg
    var fore = contrast > bgContrast ? black : white;
    return fore;
  };
  return getTxtColor(hex);
}
function getForegroundColorForColor(backColor) {
  return getForegroundColorPerBackgroundContrast(_colors.colors[backColor]);
}